jQuery(document).ready(function ($) {
  $(document).on('submit', '.contact-form', function (event) {
    event.preventDefault()
    let _this = this

    $('#captcha-error').css('display', 'none')
    var hasError = 0

    $(this)
      .find('.campo-validacao-obrigatorio')
      .each(function (index, el) {
        if ($(el).val() == '') {
          $(el).closest('.campo-default').find('.campo-alerta').fadeIn(300)
          hasError = 1
        }
      })

    let captachResponse = grecaptcha.getResponse()

    if (!captachResponse) {
      $('#captcha-error').css('display', 'block')
      hasError = 1
    }

    if (hasError) {
      $(this).stop().shake()
      return false
    }

    var btn = $(this).find('.contato-form-submit')
    var btnHtml = btn.html()
    btn.css('width', '76px').html('<i class="fa fa-spin fa-spinner"></i>')

    $.ajax({
      url: $(this).attr('action'),
      type: 'POST',
      data: $(this).serialize()
    })
      .done(function (data) {
        let dadosParaEnviarArray = $(_this).serializeArray()

        if (data.status == 'success') {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'form-contato-sucesso'
          });

          let message = ''

          if (dadosParaEnviarArray[5].value == 'quero-comprar') {
            message =
              'O Imóveis-SC é o classificado de imóveis líder em Santa Catarina. Divulgamos em nosso site anúncios de imóveis de imobiliárias e corretores de todo o estado de Santa Catarina. Faça uma pesquisa pelo imóvel que você deseja e entre em contato com os anunciantes dos imóveis de seu interesse.'
          } else {
            message = data.message
          }

          swal({
            title: 'Sucesso!',
            text: message,
            type: 'success'
          })

          grecaptcha.reset()

          $('.sa-button-container .confirm').on('click', function () {
            if (event.currentTarget.getAttribute('data-url') != '' && event.currentTarget.getAttribute('data-url') !== null) {
              location.href = event.currentTarget.getAttribute('data-url')
            }
          })

          $(event.currentTarget).find('textarea').val('')
          btn.css('width', 'auto').html('Enviado!')
          setTimeout(function () {
            btn.css('width', 'auto').html(btnHtml)
          }, 1200)

          if (event.currentTarget.getAttribute('data-close') == 1) {
            $('#modal').hide()
          }
        } else {
          swal({
            title: 'Algo deu errado!',
            html: data.message,
            type: 'error'
          })
          btn.css('width', 'auto').html('Opsss!')
          setTimeout(function () {
            btn.css('width', 'auto').html(btnHtml)
          }, 600)
        }
      })
      .fail(function () {
        swal({
          title: 'Algo deu errado!',
          html: 'Verifique se você preencheu os campos corretamente.',
          type: 'error'
        })
      })

    return false
  })
})
